<script setup lang="ts">
import { EProviders, type AdminProviderType } from '@rfc/rfc-components-library/types'
import { provide } from 'vue'
import AdminDeviceTableFilters from '../../views/AdministrationView/AdminDeviceTableFilters.vue'

provide<AdminProviderType>(EProviders.ADMIN, {
    deviceTableFilters: AdminDeviceTableFilters
})
</script>

<template>
    <slot />
</template>
